var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-footer-page-top-block" }, [
    _c("p", [
      _c(
        "a",
        {
          staticClass: "global-footer-page-top",
          attrs: { href: _vm.topScrollElementId },
          on: { click: _vm.moveSmoothScroll },
        },
        [_vm._v("ページトップへ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }